import DateUtils from 'src/app/shared/utils/date.utils';

PublicationScheduleController.$inject = [
  '$scope',
  '$mdDialog',
  'dateTime',
  'ConfirmationFactory',
  'siteName',
  'siteTypeName',
];
export function PublicationScheduleController(
  $scope,
  $mdDialog,
  dateTime,
  ConfirmationFactory,
  siteName,
  siteTypeName
) {
  $scope.closeDateTimeModal = closeDateTimeModal;
  init();

  function init() {
    if (dateTime) {
      $scope.dateTime = new Date(dateTime);
      $scope.dateTime.setSeconds(0);
      $scope.dateTime.setMilliseconds(0);
    } else {
      $scope.dateTime = null;
    }
  }

  function closeDateTimeModal(dateTimeSchedule) {
    if (dateTimeSchedule) {
      ConfirmationFactory.htmlMaterialConfirmDialog('publications/list/confirm-publish-post', {
        siteLogo: `<span class="bg-img-${siteTypeName} alc-site-icon-inline"></span>`,
        siteName: siteName,
      }).then(
        () => {
          const { date, time, timezone } = dateTimeSchedule;
          const scheduledTime = DateUtils.createDate({
            year: date.get('year'),
            month: date.get('month'),
            date: date.get('date'),
            hour: time.h,
            minute: time.m,
            second: 0,
            timezone,
          });

          $mdDialog.hide(scheduledTime.toISOString());
        },
        () => {
          $mdDialog.cancel();
        }
      );
    } else {
      $mdDialog.cancel();
    }
  }
}
